<template>
    <div class="mm-section__faq-search-container">
        <span class="headline headline--second">
            {{$t('helpPage.searchHeading')}}
        </span>
        <search-box
            :default-focus-index="-1"
            :init-value="initValue"
            isAsync
            :isLoading="suggestionsRequest && suggestionsRequest !== 'success'"
            :filtered-items="asyncSuggestion"
            :placeholder="placeholderText"
            @submit="handleSearchBoxSubmit"
            @selectItem="handleSelectItem"
            @getItems="fetchSuggestions"
            @reset="handleReset"
            @input="setSuggestionValue"
            @open="onOpen"
            :showBack="showBack"

            outerWrapperClassname='mm-section__faq-searchbox'
            classNamePrefix=''
            formClass='mm-section__faq-searchbox-wrapper'
            inputClass='searchbox-input--mm'
            iconClass='searchbox-icon--mm'
            resultsClass='searchbox__results--mm'
        />
        <div class="mm-section__faq-searchbox-info">
            {{$t('helpPage.searchDescription')}}
        </div>
    </div>
</template>

<script>
import SearchBox from "../../components/ui/SearchBox/SearchBox";

import webCMS from '../../services/WebCMS';

export default {
    props: {
        placeholderText: {type: String, default: 'Search...'},
        onSearch: { type: Function },
        showBack: {type: Boolean, default: false}
    },
    data(){
        return {
            initValue: "",
            asyncSuggestion: []
        };
    },
    components: {
        SearchBox
    },
    computed: {
        suggestionsRequest() {
            return 'success'; //this.$store.getters['search/getSuggestionsRequestState'];
        }
    },
    methods: {
        search(value) {
            webCMS.searchInHelpPages(this.axios, {searchValue: value})
                .then(res => {
                    var transformedResults = res.map(item => {
                        item.text = item.preview_text;
                        return item;
                    })
                    this.asyncSuggestion = transformedResults;
                });
        },

        onOpen(val) {
            this.search(val);
        },
        handleReset() {
            console.log('handleReset:');
        },
        handleSelectItem(item) {
            this.$router.push(this.localeRoute({name: 'help_id', params: { id: item.seo_id}}));
            this.initValue = "";
        },
        handleSearchBoxSubmit(val) {
            console.log('handleSearchBoxSubmit', val);
        },
        fetchSuggestions(val) {
            this.search(val);
        },
        setSuggestionValue(val) {
            this.initValue = val;
            console.log('setSuggestionValue: ', val);
        }
    }
}
</script>


